import { isDefined } from "@clipboard-health/util-ts";
import { Box, type SxProps, type Theme } from "@mui/material";
import { type SystemStyleObject } from "@mui/system";
import { MaterialUiProviders } from "@src/mui/providers/MaterialUiProviders";
import React from "react";

export interface LegacyRouteWrapperProps {
  children: React.ReactNode;
  rootSx?: SystemStyleObject<Theme>;
}

export function LegacyRouteWrapper(props: LegacyRouteWrapperProps) {
  const { children, rootSx } = props;
  const rootContainerSx: SxProps<Theme> = [
    { display: "flex", flexDirection: "column", flex: 1 },
    ...(isDefined(rootSx) ? [rootSx] : []),
  ];

  return (
    <MaterialUiProviders>
      <Box sx={rootContainerSx}>
        <Box
          sx={(theme) => ({
            padding: 3,
            flex: 1,
            minHeight: 0,
            // On mobile, the parent PageWrapperMobile sets overflow:hidden on direct
            // children to support touch gestures/bottom sheets. This inner Box is not
            // targeted by that selector, so it can create its own scroll context.
            [theme.breakpoints.down("md")]: {
              overflow: "auto",
            },
            // On mobile/tablet, add padding to account for fixed floating navigation
            [theme.breakpoints.down("lg")]: {
              ...(theme.size?.floatingNavigation && {
                paddingBottom: `calc(${theme.size.floatingNavigation.height} + ${
                  theme.size.floatingNavigation.margin
                } + ${theme.spacing(3)})`,
              }),
            },
          })}
        >
          {children}
        </Box>
      </Box>
    </MaterialUiProviders>
  );
}
